import { defineStore } from 'pinia'
import type { LlanaListResponse, LlanaWhere, LlanaListOptions } from '~/types/llana'
import type { Profile } from '~/types/profile'

const table_name = 'users'
type T = Profile
const default_sort = 'updated_at.desc'
const default_relations = 'users_socials,users_subscriptions'

export class UsersStore extends baseStore<T> {
	constructor() {
		super({
			table_name,
			store_name: table_name,
			default_sort,
			default_relations,
		})
	}
}

export const useUserStore = () =>
	defineStore(table_name, {
		state: () => <LlanaListResponse<T>>defaultList(),
		actions: {
			async create(data: T) {
				const store = new UsersStore()
							const { state, record } = await store.create(this.$state, data)
							this.$state = state
							return record
						},
			async get(id: number, where?: { [key: string]: string | number }): Promise<T | undefined> {
							const store = new UsersStore()
							const { state, record } = await store.get(this.$state, id, where)
							this.$state = state
							return record
						},
						async list(options?: LlanaListOptions): Promise<LlanaListResponse<T>> {
							const store = new UsersStore()
							this.$state = await store.list(this.$state, options)
							return this.$state
						},
						async search(options?: {
							fields?: string[]
							limit?: number
							offset?: number
							where?: LlanaWhere[]
							relations?: string
							page?: string
							sort?: string
						}): Promise<LlanaListResponse<T>> {
							const store = new UsersStore()
							return await store.search(options)
						},
						async reload(): Promise<LlanaListResponse<T>> {
							const store = new UsersStore()
							this.$state = await store.reload()
							return this.$state
						},
						async update(id: number, data: Partial<T>): Promise<T> {
							const store = new UsersStore()
										const { state, record } = await store.update(this.$state, id, data)
										this.$state = state
										return record
									},
	}
})
